import { Component, Input } from '@angular/core';
import { LogUpdate } from '../form-history-services/form-history.service';

@Component({
  selector: 'form-history-signatures',
  templateUrl: './form-history-signatures.component.html',
  styleUrls: ['./form-history-signatures.component.scss'],

})
export class FormHistorySignaturesComponent {
  @Input() update?: LogUpdate;
}
